import React from 'react';

import App_data from '../../config/App_data';
import { renderHTMLContent } from '../../../common/function';

function CardHeader(props) {
  const {
    headingText,
    headerImage,
    imageWidth = '30',
    showPreviousButton,
    showNextButton,
    _getPrevious,
    _getNext,
    disabledNextButton,
    disabledPreviousButton,
    className,
    headerClassName,
    children,
  } = props;
  return (
    <div className={`card-header ${headerClassName || ''}`}>
      {headerImage && (
        <img
          src={App_data.frontend_url + headerImage}
          className='margin_right_20'
          width={imageWidth}
          alt=''
        />
      )}
      {renderHTMLContent(headingText, 'span', '', { contentEditable: 'false' })}
      {' '}
      <div className='float-right text-right'>
        {showPreviousButton && (
          <button
            className={`fa fa-angle-left ques_arrow pointer_class ${disabledPreviousButton &&
              'text-secondary'}`}
            onClick={_getPrevious}
            disabled={disabledPreviousButton}
          />
        )}
        {showNextButton && (
          <button
            className={`fa fa-angle-right ques_arrow pointer_class ${disabledNextButton &&
              'text-secondary'}`}
            onClick={_getNext}
            disabled={disabledNextButton}
          />
        )}
        {children}
      </div>
    </div>
  );
}

export default CardHeader;



// WEBPACK FOOTER //
// ./src/views/ESG/CustomCard/CardHeader.jsx